import {useQuery} from "@tanstack/react-query";
import {readAccountBasicInfoApi} from "../../../../../api/correspondent/CorresspondentApi";

/**
 * 거래처 기본 정보 가져오기
 * @param props
 * @returns
 */
export const useReadAccountBasicInfo = (id: string) => {
    const {data} = useQuery({
        queryKey: ["readAccountBasicInfo", id],
        queryFn: async () => (id ? await readAccountBasicInfoApi(id) : null),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
        enabled: id !== "",
    });

    return {data};
};
